import { FunctionComponent } from 'react'
import styled from 'styled-components/macro'
import { Box, IconButton } from '@material-ui/core'
import { ReactComponent as SunIcon } from 'icons/sun.svg'
import { ReactComponent as MoonIcon } from 'icons/moon.svg'

//@ts-ignore
import { useTheme } from 'styled-components'
import { useThemeSwitch } from 'hooks/theme'
import { Button } from 'common/atoms/Button/Button'

export const StyledIcon = styled.svg`
  height: 0.7em;
  width: 0.7em;
  margin-right: 0.625em;
  font-weight: bold;
`

const StyledSunIcon = styled(SunIcon)`
  && {
    height: 15px;
    width: 15px;
  }
`
const StyledMoonIcon = styled(MoonIcon)`
  && {
    height: 15px;
    width: 15px;
  }
`

export const MainNav: FunctionComponent<{
  onMemberLogin: () => void
  onPartnerLogin: () => void
  toggleDrawer: (open: boolean) => void
}> = ({ onMemberLogin, onPartnerLogin, toggleDrawer }) => {
  const theme = useTheme()
  const { mode, switchTheme } = useThemeSwitch()

  return (
    <Box p="1em">
      <Box display="flex" flexDirection="row" alignItems="center" color={theme.colors.accent1} gridGap="1em">
        <Box>
          <Button
            design='primary'
            onClick={() => {
              onMemberLogin()
              toggleDrawer(false)
            }}
            small
            fullWidth
          >
            MEMBER LOGIN
          </Button>
        </Box>
        <IconButton size="small" onClick={() => switchTheme()}>
          {mode === 'dark' ? <StyledMoonIcon /> : <StyledSunIcon />}
        </IconButton>
      </Box>
    </Box>
  )
}
